<div class="tw-flex tw-gap-1 tw-items-center">
  <img [src]="profile?.Logo" class="tw-w-10">
  {{profile?.Title || businessId}}
</div>
